import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';

export default function AuthCallback() {
  const navigate = useNavigate();
  const [message, setMessage] = useState('Signing you in...');

  useEffect(() => {
    const handleAuth = async () => {
      try {
        const url = new URL(window.location.href);
        const code = url.searchParams.get('code');

        if (code) {
          const { error } = await supabase.auth.exchangeCodeForSession(code);

          if (error) {
            console.error('exchangeCodeForSession error:', error.message);
            setMessage('Error signing in. Please try again.');
            return;
          }
        }

        const {
          data: { session },
          error,
        } = await supabase.auth.getSession();

        if (error) {
          console.error('getSession error:', error.message);
          setMessage('Unable to verify your session.');
          return;
        }

        if (session?.user) {
          navigate('/my-clubs', { replace: true });
        } else {
          setMessage('No active session found. Please try again.');
        }
      } catch (err) {
        console.error('Auth callback error:', err);
        setMessage('Something went wrong during sign-in.');
      }
    };

    handleAuth();
  }, [navigate]);

  return (
    <div className="flex min-h-[calc(100vh-80px)] items-center justify-center bg-white px-6">
      <div className="w-full max-w-md rounded-3xl border border-black/10 bg-white p-8 text-center shadow-sm">
        <h1 className="text-2xl font-semibold">Run Collective</h1>
        <p className="mt-3 text-gray-500">{message}</p>
      </div>
    </div>
  );
}